var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 51,
    viewBox: "0 0 45 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1429 21.25C40.1429 34 23.0949 46.75 23.0949 46.75C23.0949 46.75 6.04688 34 6.04688 21.25C6.04688 16.7413 7.843 12.4173 11.0401 9.22918C14.2373 6.04107 18.5735 4.25 23.0949 4.25C27.6163 4.25 31.9526 6.04107 35.1497 9.22918C38.3468 12.4173 40.1429 16.7413 40.1429 21.25V21.25Z",
    stroke: "#E83C40",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0961 27.625C26.6269 27.625 29.4892 24.7708 29.4892 21.25C29.4892 17.7292 26.6269 14.875 23.0961 14.875C19.5654 14.875 16.7031 17.7292 16.7031 21.25C16.7031 24.7708 19.5654 27.625 23.0961 27.625Z",
    stroke: "#E83C40",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMap);
export default __webpack_public_path__ + "static/media/icon-map.7cab17d284c44245cb842d8166857b81.svg";
export { ForwardRef as ReactComponent };